import { createErrorLogger, Observable } from './observable';
export function createErrorLoggingObservable(name, logger) {
    return new Observable(createErrorLogger(name, logger));
}

//# sourceMappingURL=error-logging-observable.js.map